import React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";
import BlackArrowDownIcon from "../../../assets/icons/admin_page_icons/black_arrow_down_icon";

export const itemRowBase =
	"flex items-center gap-[10px] h-[40px] px-4 w-full transition-[0.2s] cursor-pointer text-text-caption dark:text-text-dark-muted text-[14px] font-normal leading-[140%] no-underline bg-transparent border-none border-b border-[#f2f2f8] dark:border-white/10 last:border-b-0 text-left [&_svg]:flex-shrink-0 [&_svg]:w-[18px] [&_svg]:h-[18px] hover:bg-[rgba(114,95,237,0.14)] dark:hover:bg-white/5";

export const SectionItems = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
	<div
		className="flex flex-col bg-white dark:bg-dark-card rounded-[12px] border border-[#ebebf5] dark:border-white/10 overflow-hidden"
		{...props}
	>
		{children}
	</div>
);

export const ItemRow = ({
	children,
	$active,
	className,
	...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { $active?: boolean }) => (
	<button
		className={`${itemRowBase}${$active ? " !bg-[rgba(114,95,237,0.12)] !text-primary" : ""}${className ? " " + className : ""}`}
		{...props}
	>
		{children}
	</button>
);

export const NavItemRow = ({ children, className, ...props }: NavLinkProps) => (
	<NavLink
		className={({ isActive }) =>
			`${itemRowBase}${isActive ? " !bg-[rgba(114,95,237,0.12)] !text-primary" : ""}${className ? " " + className : ""}`
		}
		{...props}
	>
		{children}
	</NavLink>
);

export const ItemLabel = ({ children, ...props }: React.HTMLAttributes<HTMLSpanElement>) => (
	<span className="flex-1" {...props}>
		{children}
	</span>
);

// `!` because the row sizes every svg inside it to 18px, which would otherwise win here.
export const ItemTrailingIcon = ({ children, ...props }: React.HTMLAttributes<HTMLSpanElement>) => (
	<span
		className="inline-flex items-center justify-center w-[12px] h-[12px] flex-[0_0_12px] [&_svg]:!w-[12px] [&_svg]:!h-[12px]"
		{...props}
	>
		{children}
	</span>
);

interface Props {
	title: string;
	isExpanded: boolean;
	onToggle: () => void;
	children: React.ReactNode;
	testId?: string;
}

const NavSection = ({ title, isExpanded, onToggle, children, testId }: Props) => (
	<div className="flex flex-col" data-testid={testId}>
		<button
			type="button"
			className="flex items-center justify-between w-full px-3 h-[30px] cursor-pointer text-text-secondary dark:text-text-dark-muted text-[12px] font-medium tracking-[0.4px] uppercase"
			onClick={onToggle}
		>
			<span>{title}</span>
			<span
				className={`inline-flex transition-transform duration-200${isExpanded ? "" : " -rotate-90"}`}
			>
				<BlackArrowDownIcon color="var(--color-primary)" />
			</span>
		</button>
		{isExpanded && <SectionItems>{children}</SectionItems>}
	</div>
);

export default NavSection;
